export const get = (base, property, defaultValue) => {
  return base[property] || defaultValue;
};
